{% block sw_cms_element_acris_faq_preview %}
    <div class="sw-cms-el-preview-acris-faq">
        <div class="acris-faq-question-title">
            <p>Lorem ipsum?</p><span>+</span>
        </div>
        <div class="acris-faq-question-content">
            <p>Lorem ipsum dolor sit amet.</p>
        </div>
    </div>
{% endblock %}
